import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {WebsiteService} from "../../../../website.service";
import {DialogService} from "../../../../../../ng2-bootstrap-modal/dialog.service";
import {Store} from "@ngrx/store";
import * as fromStore from '../../../../../store';
import {Observable} from "rxjs";
import {DbModalService} from "../../../../../modules/modal/modal";
import {TypeUtils} from "../../../../../shared/utils/type-utils";
import {UserSubscription} from "../../../../../user/user-subscription";

export interface IAIBuilderPage {
  id: number;
  title: string;
  recreated: boolean;
  link?: string;
  condition?: string;
  lastModified: Date;
  modifiedDate: Date;
  postedDate: Date;
  pageStatus: 'draft' | 'publish';
  createdWith: string;
  pageType: string;
  frontPage: boolean;
  templateType: string;
  isAiKit?: boolean;
  regenerationCount?: any;
}

@Component({
    selector: 'db-ai-builder-pages-table',
    templateUrl: './ai-builder-pages-table.component.html',
    styleUrls: ['./ai-builder-pages-table.component.scss'],
    standalone: false
})
export class AiBuilderPagesTableComponent implements OnInit, OnChanges {

  @Input() demoUser?: boolean;
  @Input() heads: string[];
  @Input() websiteId: number;
  @Input() websiteHosted: boolean;
  @Input() websiteAdminUrl: string;
  @Input() websiteHomeUrl: string;
  @Input() adminElementorUrl: string;
  @Input() activeTab: string;
  @Input() searchVal: string;
  @Input() showCreatedWithAiBtn?: boolean;
  @Input() currentUserSubscription?: UserSubscription;

  public pages: IAIBuilderPage[] = [];
  public loading: boolean;
  public isMobile: boolean;
  public createdPagesLoading$: Observable<boolean>;
  productPages = ['twbb_single_product', 'twbb_archive_product'];

  constructor(
    private _store: Store<fromStore.DbStoreState>,
    private _websiteService: WebsiteService,
    private _modalService: DbModalService,
    private _dialogService: DialogService
  ) {
  }

  ngOnInit() {
    this.isMobile = window.innerWidth <= 991;
    this.createdPagesLoading$ = this._store.select(fromStore.getCreatedPagesLoading(this.websiteId));
    this._getCreatedPages();
  }

  ngOnChanges() {
    this.loading = false;
    this._getCreatedPages();
  }

  private _getCreatedPages(): void {
    this._store.select(fromStore.getCreatedPages(this.websiteId))
      .subscribe((pages) => {
        if (pages && TypeUtils.isDefined(pages) && !TypeUtils.isEmpty(pages)) {
          this.pages = pages;
          this._filterPagesList(pages);
        }
      });
  }

  private _filterPagesList(pages): void {
    let pagesList = [];
    switch (this.activeTab) {
      case 'pages':
        /* show front page first */
        const allPages = pages.filter((page) => page && page.pageType === 'page');
        allPages.sort((a, b) => (a.modifiedDate < b.modifiedDate ? 1 : -1));
        pagesList = allPages.sort((page1: IAIBuilderPage, page2: IAIBuilderPage) => {
          if (page1 && page2) {
            if (!page1.frontPage && page2.frontPage) {
              return 1;
            } else if (page1.frontPage && !page2.frontPage) {
              return -1;
            }
          }
          return 0;
        });
        break;
      case 'single':
        pagesList = pages.filter((page) => page && (page.templateType === 'twbb_single' || page.templateType === ('twbb_single_product')) && page.pageType === 'elementor_library');
        break;
      case 'archive':
        pagesList = pages.filter((page) => page && (page.templateType === 'twbb_archive' || page.templateType === 'twbb_archive_products') && page.pageType === 'elementor_library');
        break;
      case 'header':
      case 'footer':
      case 'slide':
        pagesList = pages.filter((page) => page && page.templateType === ('twbb_' + this.activeTab) && page.pageType === 'elementor_library');
        break;
    }
    this.pages = pagesList;
  }

  public actionClicked($event) {
    this.loading = !!$event;
  }

}
